import { render, staticRenderFns } from "./carnival-imgs-swiper.vue?vue&type=template&id=f85e30f4&scoped=true"
import script from "./carnival-imgs-swiper.vue?vue&type=script&lang=js"
export * from "./carnival-imgs-swiper.vue?vue&type=script&lang=js"
import style0 from "./carnival-imgs-swiper.vue?vue&type=style&index=0&id=f85e30f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85e30f4",
  null
  
)

export default component.exports